import { render, staticRenderFns } from "./DashboardTooltipPill.vue?vue&type=template&id=f99d14e0"
import script from "./DashboardTooltipPill.vue?vue&type=script&lang=js"
export * from "./DashboardTooltipPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports